import services from "./services";
import areaSelect from 'area-select';
import followUpDialog from 'follow-up-dialog';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import schoolDetails from '../components/schoolDetails.vue';

export default {
    mixins: [services],
    components: {
        'area-select': areaSelect,
        'follow-up-dialog': followUpDialog,
        schoolDetails
    },
    data() {
        return {
            /* 跟进情况列表 */
            followUpListVisiable: false,
            addbjbtndisabled: false,
            followUpList: [], //列表数据
            followUpTotalSize: 0, //列表总条数
            currentId: null,
            followItem: {},
            /*主页*/
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            ProjectTypes: [],
            projectType: MAP_LIST.INTENT_PROJECT,
            /*搜索*/
            searchVisiable: false,
            form: this.getInitFormData(),
            areaInfo: this.getInitAreaData(),
            comeList: [{
                id: '',
                text: '全部'
            }, {
                id: '0',
                text: 'ERP新建'
            }, {
                id: '3',
                text: '代理商APP'
            }, {
                id: '4',
                text: '开通申请表'
            }, {
                id: '5',
                text: '会销申请'
            }],
            /* 班级 */
            GradeList: [{
                id: "1",
                text: "托班"
            }, {
                id: "2",
                text: "小班"
            }, {
                id: "4",
                text: "中班"
            }, {
                id: "8",
                text: "大班"
            }, {
                id: "16",
                text: "学前班"
            }],
            CurrentRowId: "", //表格当前选中园所
            ClassList: [], //班级列表
            dialogTableVisible: false, //表格弹窗显示
            //班级分页
            TpageIndex: 1,
            TpageSize: 10,
            TtotalSize: '',
            TpageSizes: [10, 20, 50],
            /*添加修改班级*/
            addclassVisisble: false,
            SubjectList: [],
            ActionSubject: [],
            classform: this.getClassFormData(),
            classEdit: false, //编辑课程
            classdialogContent: "", //弹窗内容

            /*班主任*/
            classCurrentRow: {}, //表格当前选中的班级
            TeacherVisible: false, //班主任弹窗的显示与隐藏
            TeacherForm: {
                Classid: "",
                UserName: "",
                PhoneNo: "",
                uid: 0,
            }
        }
    },
    methods: {
        getInitFormData() {
            return cloneDeep({
                SchoolName: "",
                PrincipalName: "",
                PhoneNo: "",
                createTimeStart: "",
                createTimeEnd: "",
                ProvId: "",
                CityId: "",
                AreaId: "",
                SchoolCome: "",
                Code: "",
                Account: "",
                AgentCustomerId: "",
                ProjectTypes: ""
            });
        },
        getInitAreaData() {
            return cloneDeep({
                Provinces_Id: '',
                City_Id: '',
                Area_Id: ''
            });
        },
        getClassFormData() {
            return cloneDeep({
                Id: 0,
                SchoolId: 0,
                ClassName: "",
                ClassNick: "",
                Grade: "",
                Subject: "",
                Option: false,
                SN: "",
                MAC: "",
                IsSchedule: 1
            });
        },
        handleview(item) {
            this.$refs.schoolDetails.show({
                Id: item.Id,
                isReadonly: true
            });
        },
        //打开跟进情况列表
        checkFollowUpList(id) {
            this.getFollowList({
                id: id
            }); //跟进情况列表
            this.followUpListVisiable = true;
            this.currentId = id;
        },
        //更新跟进情况列表
        refreshFollowUpList(type, val) {
            let options = {
                id: this.currentId
            };
            options[type] = val;
            this.getFollowList(options);
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        }, //分页选定行
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        }, //分页监听dd页面
        ThandleSizeChange: function (val) {
            this.TpageSize = val;
            var a = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: this.CurrentRowId,
                pageSize: this.TpageSize
            };
            this.getClassList(a);
        }, //分页选定行
        ThandleCurrentChange: function (val) {
            this.TpageIndex = val;
            var a = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: this.CurrentRowId,
                pageIndex: this.TpageIndex,
                pageSize: this.TpageSize
            };
            this.getClassList(a);
        },
        //分页监听dd页面
        /*搜索*/
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        search() {
            this.form.ProjectTypes = this.ProjectTypes.join(",");
            this.areaInfo = this.$refs.areaForm.getAreaData();
            this.form.ProvId = this.areaInfo.Provinces_Id;
            this.form.CityId = this.areaInfo.City_Id;
            this.form.AreaId = this.areaInfo.Area_Id;
            this.getList();
        },
        reset() {
            this.areaInfo = this.getInitAreaData();
            this.form = this.getInitFormData();
            this.$refs.areaForm.resetFields();
            this.ProjectTypes = [];
            this.getList();
        },
        /*关闭和开通联帮在线*/
        currentRow(newRow, oldRow) {
            this.CurrentRowId = newRow.Id;
        },
        openLBZX() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.CurrentRowId
            };
            if (this.CurrentRowId == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择表格中要开通联帮在线的园所',
                    type: 'warning'
                })
            } else {
                this.$confirm('开通选中园所的联帮在线项目？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.open(Params);
                }).catch(() => {
                    return false;
                });
            }
        },
        closeLBZX() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.CurrentRowId
            };
            if (this.CurrentRowId == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择表格中要关闭联帮在线的园所',
                    type: 'warning'
                })
            } else {
                this.$confirm('关闭选中园所的联帮在线项目？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.close(Params);
                }).catch(() => {
                    return false;
                });
            }
        },
        /*班级（增加，删除，修改） */
        actionClassList() {
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                SchoolId: this.CurrentRowId,
                pageIndex: this.TpageIndex,
                pageSize: this.TpageSize
            };
            if (this.CurrentRowId == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择表格中的园所',
                    type: 'warning'
                })
            } else {
                this.getClassList(params);
                this.getSubjectList();
                this.dialogTableVisible = true;
            }
        },
        addClass() {
            this.addclassVisisble = true;
            this.classdialogContent = "添加班级";
        },
        delClass(val) {
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: val
            };
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ActionDelClass(params);
            }).catch(() => {
                return false;
            });

        },
        editClass(val) {
            this.addclassVisisble = true;
            this.classdialogContent = "修改班级";
            this.classEdit = true;
            var params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                ClassId: val
            };
            this.ActiongetOneClass(params);
        },
        classSubmit() {
            this.classform.SchoolId = this.CurrentRowId;
            if (this.classform.Option) {
                this.classform.Option = 1;
            } else {
                this.classform.Option = 0;
            }
            this.classform.Subject = this.ActionSubject.join(",")
            this.ActionclassSubmit(this.classform);
        },
        classDialogClose() {
            this.addclassVisisble = false;
            this.ActionSubject = [];
            this.classform = this.getClassFormData();
            this.classEdit = false;
        },
        TableDialogClose() {

        },
        /* 设置删除班主任 */
        classcurrentRow(newRow, oldRow) {

            if (JSON.stringify(newRow) != null) {
                this.classCurrentRow = newRow;
            } else {
                this.classCurrentRow = "";
            }
        },
        setTeacher() {
            if (this.classCurrentRow.ClassId == "") {
                this.$notify({
                    title: "警告",
                    message: "还没有选中班级",
                    type: "warning"
                })
            } else {
                this.TeacherVisible = true;
                this.TeacherForm.UserName = this.classCurrentRow.UserName;
                this.TeacherForm.PhoneNo = this.classCurrentRow.TeacherPhone;
            }
        },
        delTeacher() {
            if (this.classCurrentRow.ClassId == "") {
                this.$notify({
                    title: "警告",
                    message: "还没有选中班级",
                    type: "warning"
                })
            } else {
                this.$confirm('确定删除班主任？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var params = {
                        Sid: this.sysSid,
                        Session: this.sysSession,
                        classId: this.classCurrentRow.ClassId
                    };
                    this.ActiondelTeacher(params);
                }).catch(() => {
                    return false;
                });
            }
        },
        TeacherDialogClose() {
            this.TeacherVisible = false;
            this.TeacherForm = {
                Classid: "",
                UserName: "",
                PhoneNo: "",
                uid: 0,
            }
        },
        addTeacher() {

            this.TeacherForm.Classid = this.classCurrentRow.ClassId;

            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "班主任名称",
                    value: this.TeacherForm.UserName,
                    required: true
                }, {
                    name: "手机号码",
                    value: this.TeacherForm.PhoneNo,
                    phone: true
                }]
            });

            if (!flag) {
                return;
            }

            if (this.classCurrentRow.TeacherId == 0) {
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    Classid: this.TeacherForm.Classid,
                    UserName: this.TeacherForm.UserName,
                    PhoneNo: this.TeacherForm.PhoneNo,
                    uid: 0
                }
            } else {
                var Params = {
                    Sid: this.sysSid,
                    Session: this.sysSession,
                    Classid: this.TeacherForm.Classid,
                    UserName: this.TeacherForm.UserName,
                    PhoneNo: this.TeacherForm.PhoneNo,
                    uid: this.classCurrentRow.TeacherId
                }
            }
            this.ActionAddTeacher(Params);
        }
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/ViewofficialSchool/vm.js